export default [
  {
    path: '/notificacoes',
    name: 'notificacoes',
    component: () => import('@/app-modulo/comuns/notificacao/NotificacaoConfiguracao.vue'),
    meta: {
      resource: 'notificacoes',
      action: 'create',
      pageTitle: 'Configurações de notificações',
      breadcrumb: [],
    },
  },
]
